
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 7H4","stroke":"#47D061"}}),_c('path',{attrs:{"d":"M15.285 7.429a.5.5 0 000-.858l-3.528-2.117a.5.5 0 00-.757.43v4.233a.5.5 0 00.757.429l3.528-2.117zM16.715 6.571a.5.5 0 000 .858l3.528 2.117a.5.5 0 00.757-.43V4.884a.5.5 0 00-.757-.429l-3.528 2.117z","fill":"#47D061"}}),_c('path',{attrs:{"d":"M28 7h-7","stroke":"#47D061"}}),_c('path',{attrs:{"d":"M4 1h24v-2H4v2zm27 3v6h2V4h-2zm-3 9H4v2h24v-2zM1 10V4h-2v6h2zm3 3a3 3 0 01-3-3h-2a5 5 0 005 5v-2zm27-3a3 3 0 01-3 3v2a5 5 0 005-5h-2zm-3-9a3 3 0 013 3h2a5 5 0 00-5-5v2zM4-1a5 5 0 00-5 5h2a3 3 0 013-3v-2z","fill":"#F8F8F8"}})])
          )
        }
      }
    